export default __webpack_public_path__ + "static/media/Theme12.7ec8462d.jpg";